const PAGES = {
  Cars: '/',
  CarId: '/cars/:id',
  Models: '/models',
  Comparison: '/comparison',
  Favorites: '/favorites',
  404: '/404',
  500: '/500',
} as const;

export const PAGE_LIST = Object.values(PAGES);

export const PAGE_PATHS = PAGE_LIST.map(path => ({ path }));

export default PAGES;
